/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NoticeRequestOrderListPage = lazyLoad(
  () => import('./index'),
  module => module.NoticeRequestOrderListPage
);
